import { TemplateRef } from '@angular/core';
import { PersonGroupsModel } from '@models/person-groups.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableAction,
  DatasetTableConfig,
  deleteAction,
  editAction,
  formattedColumn,
  numberColumn,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

export interface CreatePersonGroupsTableConfigDependencies {
  processingIds: () => string[];
  templates?: {
    sharedCell: TemplateRef<CellTemplateContext<PersonGroupsModel.PersonGroupListDocument>>;
  };
  onRowClick?: (row: PersonGroupsModel.PersonGroupListDocument) => void;
}

export function createPersonGroupsTableConfig(
  dependencies: CreatePersonGroupsTableConfigDependencies,
): DatasetTableConfig<PersonGroupsModel.PersonGroupListDocument> {
  const columnBuilder = new ColumnBuilder<PersonGroupsModel.PersonGroupListDocument>();

  const isProcessing = (row: PersonGroupsModel.PersonGroupListDocument): boolean =>
    new Set(dependencies.processingIds()).has(row._id);

  const isListAdminOnGroup = (row: PersonGroupsModel.PersonGroupListDocument): boolean =>
    row.activeOrgAccessRole === PersonGroupsModel.ShareAccessRole.Admin;

  const shareWithLinkIcon: DatasetTableAction<PersonGroupsModel.PersonGroupListDocument> = {
    id: 'share',
    icon: 'ui-icon-link',
    iconType: 'ui-icon',
    label: 'COMMON.SHARE',
    tooltip: 'COMMON.SHARE',
    disabled: (row) => isProcessing(row),
    showInline: true,
  };

  const sharedColumn = dependencies.templates?.sharedCell
    ? columnBuilder
        .column('accessListCounter')
        .label('PERSON_GROUPS.TABLE.SHARED')
        .width('minmax(100px, 0.45fr)')
        .cellTemplate(dependencies.templates.sharedCell)
        .mobileVisible()
        .alignCenter()
        .build()
    : formattedColumn<PersonGroupsModel.PersonGroupListDocument>(
        'accessListCounter',
        'PERSON_GROUPS.TABLE.SHARED',
        () => '',
        {
          width: 'minmax(100px, 0.45fr)',
          mobileVisible: true,
          alignCenter: true,
        },
      );

  const tableBuilder = new TableConfigBuilder<PersonGroupsModel.PersonGroupListDocument>()
    .columns([
      textColumn<PersonGroupsModel.PersonGroupListDocument>('name', 'PERSON_GROUPS.TABLE.NAME', {
        width: 'minmax(200px, 1fr)',
        mobileVisible: true,
        cardMode: 'label-only',
      }),
      numberColumn<PersonGroupsModel.PersonGroupListDocument>('personsCounter', 'PERSON_GROUPS.TABLE.USERS', {
        width: 'minmax(100px, 0.5fr)',
        mobileVisible: true,
        alignCenter: true,
        cardIcon: 'ui-icon-users',
      }),
      // sharedColumn,
    ])
    .actions([
      // shareWithLinkIcon,
      editAction<PersonGroupsModel.PersonGroupListDocument>({
        visible: (row) => isListAdminOnGroup(row),
        disabled: (row) => isProcessing(row),
      }),
      deleteAction<PersonGroupsModel.PersonGroupListDocument>({
        visible: (row) => isListAdminOnGroup(row),
        disabled: (row) => isProcessing(row),
      }),
    ])
    .actionsWidth(120)
    .rowHeight(52)
    .trackBy('_id');

  if (dependencies.onRowClick) {
    tableBuilder.onRowClick(dependencies.onRowClick);
  }

  return tableBuilder.build();
}
